// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2vr9-","sendOtp":"AuthorizeToLogin_sendOtp__i36Lt"};